import { Link } from "react-router-dom";
import { ShieldAlert, ArrowRight } from "lucide-react";

export default function InsuranceStrip() {
  return (
    <section className="bg-[#16A34A] text-white border-y border-[#15803D]">
      <div className="container mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-white text-[#16A34A] flex items-center justify-center shrink-0">
            <ShieldAlert className="w-6 h-6" />
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/80">Insurance Claim</div>
            <div className="font-display font-black text-xl tracking-tight">Your insurer asked us to quote? Send us your photos.</div>
          </div>
        </div>
        <Link
          to="/insurance"
          data-testid="insurance-strip-cta"
          className="bg-white text-[#16A34A] px-6 py-3 font-semibold hover:bg-zinc-100 transition-colors inline-flex items-center gap-2 whitespace-nowrap"
        >
          Submit photos <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
